/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { CSSProperties, type JSX } from 'react'

export type AvatarProps = JSX.IntrinsicElements['span'] & {
  src: string
  size: number
}

export const Avatar = ({ src, size, ...props }: AvatarProps) => {
  const avatarStyle = css`
    display: inline-flex;
    border-radius: 50%;
    align-items: center;
    text-align: center;
    position: relative;
    vertical-align: top;
    flex-shrink: 0;
    width: ${size}px;
    height: ${size}px;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      display: block;
    }
  `
  return (
    <span css={avatarStyle} {...props}>
      <img src={src} alt="" />
    </span>
  )
}
